export const InfoTooltip = ({ text }) => {
  if (!Array.isArray(text)) return null;
  return (
    <span className="table-tooltip-wrapper">
      <span style={{ color: "black" }}> ⓘ</span>
      <div className="table-tooltip-content">
        {text.map((item) => (
          <div key={item.id} className="tooltip-line">
            {item.text}
          </div>
        ))}
      </div>
    </span>
  );
};
